import { ComponentMultiStyleConfig } from '@chakra-ui/react';
import type { StyleFunctionProps, PartsStyleObject } from '@chakra-ui/theme-tools';
import { mode } from '@chakra-ui/theme-tools';

import {
  avatarBoxStyles,
  containerSizeStyleMap,
  staggeredFirstIconStyleMap,
  staggeredLastIconStyleMap
} from 'atoms/Avatar/AvatarTheme';
import TYPOGRAPHY from 'theme/Typography';

const AvatarGroupTheme: ComponentMultiStyleConfig = {
  parts: ['avatarList', 'excessLabel'],
  baseStyle: (props: StyleFunctionProps): PartsStyleObject => {
    const { staggered, size, avatars } = props;
    const isStaggered = avatars?.length > 1 && staggered;
    return {
      avatarList: {
        display: 'flex',
        flexDirection: staggered ? 'column' : 'row',
        gap: staggered ? '0' : '4px',
        '.chakra-avatar, .excess-avatar-label': isStaggered && {
          _first: { ...staggeredFirstIconStyleMap[size] },
          _last: {
            position: 'absolute',
            ...staggeredLastIconStyleMap[size]
          }
        }
      },
      excessLabel: {
        ...avatarBoxStyles,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1,
        fontWeight: TYPOGRAPHY.fontWeights.medium,
        backgroundColor: mode('silver.base', 'black.lightest')(props),
        color: mode('grey.base', 'silver.base')(props)
      }
    };
  },
  sizes: {
    sm: {
      excessLabel: containerSizeStyleMap.sm
    },
    md: {
      excessLabel: containerSizeStyleMap.md
    },
    lg: {
      excessLabel: containerSizeStyleMap.lg
    }
  }
};

export default AvatarGroupTheme;
